import React from 'react';
import style from './Recommendations.module.css';
import RecommendationsList from '../../Data/RecommendationsList';

const Recommendations = () => {
  return (
    <section className={style.Recommendations} id='recommendations' data-reveal="fade">
      <div className={style.Container}>
        <header className={style.Header} data-reveal="up">
          <h2 className={style.Title}>Recommendations</h2>
          <p className={style.Subtitle}>What collaborators and clients say</p>
        </header>

        <div className={style.CardsGrid} data-reveal="up">
          {RecommendationsList.map((rec) => (
            <article key={rec.id} className={`${style.Card} hover-raise`}>
              <div className={style.Top}>
                <img className={style.Avatar} src={rec.photo} alt={`${rec.name} avatar`} />
                <div className={style.Meta}>
                  <h3 className={style.Name}>{rec.name}</h3>
                  <span className={style.TitleSmall}>{rec.title}</span>
                </div>
              </div>

              <p className={style.Text}>&ldquo;{rec.recommendation}&rdquo;</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Recommendations;
